ci_states.state('publishers', {
    url: '/publishers',
    templateUrl: 'partials/publisher/publisher_list.html',
    controller: 'PublisherListController',
    ncyBreadcrumb: {
        label: 'Publishers'
    }
}).state('publishers_view', {
    url: '/publishers/:id',
    abstract: true,
    templateUrl: 'partials/publisher/publisher_view.html',
    controller: 'PublisherViewController',
    ncyBreadcrumb: {
        parent: 'publishers',
        label: '{{ publisher.name }}'
    }
}).state('publishers_view.info', {
    url: '/info',
    templateUrl: 'partials/publisher/publisher_view_info.html',
    ncyBreadcrumb: {
        label: 'Info'
    }
}).state('publishers_view.ad_types', {
    url: '/ad_types',
    templateUrl: 'partials/publisher/publisher_view_ad_types.html',
    ncyBreadcrumb: {
        label: 'Ad Types'
    }
}).state('publishers_view.postbacks', {
    url: '/postbacks',
    templateUrl: 'partials/publisher/publisher_view_postbacks.html',
    ncyBreadcrumb: {
        label: 'Postbacks'
    }
}).state('publishers_view.recent_postbacks', {
    url: '/recent_postbacks',
    controller: 'PublisherRecentPostbacksController',
    templateUrl: 'partials/publisher/recent_postbacks_list.html',
    ncyBreadcrumb: {
        label: 'Recent Postbacks'
    }
}).state('publishers_view.campaigns', {
    url: '/campaigns?start_date&end_date&run_status&hide_zero_items',
    templateUrl: 'partials/publisher/publisher_view_campaigns.html',
    controller: 'PublisherCampaignListController',
    reloadOnSearch: true,
    ncyBreadcrumb: {
        label: 'Campaigns'
    }
}).state('publishers_wizard', {
    url: '/publishers/wizard',
    templateUrl: 'partials/publisher/wizard/view.html',
    controller: 'PublisherWizardCtrl',
    ncyBreadcrumb: {
        parent: 'publishers',
        label: 'Wizard'
    }
}).state('publishers_wizard_id', {
    url: '/publishers/:id/wizard',
    templateUrl: 'partials/publisher/wizard/view.html',
    controller: 'PublisherWizardCtrl',
    ncyBreadcrumb: {
        parent: function ($scope) {
            return 'publishers_view({id:' + $scope.stateParams.id + '})';
        },
        label: 'Wizard'
    }
});